import Country from '../../models/Country'
import requestAction from '../../utils/requestAction'

export const fetchCountry = (countryId: string, handleResponse?: (response: Country ) => void) =>
  requestAction('COUNTRY_DETAIL')(`countries/${countryId}`, 'GET',
    undefined,
    undefined,
    undefined,
    (_dispatch, _getState, response) => { if (response && handleResponse) handleResponse(response.country) }
  )
